import { GoogleMap } from '@capacitor/google-maps';
import { GoogleMapsControllerFactory } from '../controllers/google-maps.controller';
import { Injectable } from '@angular/core';
import { GoogleMapsModule } from '../modules/google-maps.module';
import { GoogleMapsState } from '../google-maps.state';
import { GoogleMapsConfig } from '../models/google-maps.config';
import { GoogleMapsShutdownControllerFactory } from '../controllers/google-maps-shutdown.controller';

@Injectable({
  providedIn: GoogleMapsModule
})
export class GoogleMapsStateReadyFactory {
  constructor(
    private googleMapsControllerFactory: GoogleMapsControllerFactory,
    private googleMapsShutdownControllerFactory: GoogleMapsShutdownControllerFactory
  ) {}

  public async create(map: GoogleMap): Promise<GoogleMapsState.Ready> {
    const controller = await this.googleMapsControllerFactory.create(map);
    const shutdownController = this.googleMapsShutdownControllerFactory.create(map);
    const state = new GoogleMapsState.Ready(controller, shutdownController);

    return state;
  }
}
